import { createFileRoute } from '@tanstack/react-router'
import { requireGuest } from '@/lib/auth-guard'

export const Route = createFileRoute('/reset-password')({
  validateSearch: (raw: Record<string, unknown>) => ({
    token: typeof raw.token === 'string' ? raw.token : '',
  }),
  beforeLoad: () => requireGuest(),
})
